import { Channel, PaymentAmounts } from 'common/types';
import { TFunction } from 'react-i18next';
import { getDepositStatus } from './PaymentSection/DepositSection/utils';
import { StatusVariant } from './PaymentSection/utils';

export const getChannelName = (channel: Channel, t: TFunction) => {
	switch (channel) {
		case 'ADMIN':
			return t('product.adminChannel');
		case 'STORE':
			return t('product.selfServiceChannel');
		case 'ONLINE':
			return t('product.onlineChannel');
		case 'PAYLINK':
			return t('product.paylinkChannel', 'Rental link');
		default:
			return null;
	}
};

export const getDepositStatusVariant = (
	depositType: 'payment' | 'other' | 'no-deposit',
	paymentAmount: PaymentAmounts,
): StatusVariant | undefined => {
	if (depositType === 'no-deposit') {
		return 'neutral';
	}
	if (depositType === 'other') {
		return 'warning';
	}
	return getDepositStatus(paymentAmount).variant;
};
